export default {
  common: {
    Unsaved_changes: 'Незбережені зміни',
    There_are_unsaved_changes_in_this_comment: 'У цьому коментарі є незбережені зміни.',
    Continue_editing: 'Продовжити редагування',
    Drop_changes: 'Відкинути зміни',
    Add_link: 'Додати посилання',
    Enter_a_URL: 'Введіть URL',
    Link_text: 'Текст',
    Enter_link_text: 'Введіть текст для показу',
    Cancel: 'Скасувати',
    Add: 'Додати',
    Executed_by_agent: 'Виконано {agent}',
    Save: 'Зберегти',
    Edit: 'Редагувати',
    Update: 'Оновити',
    Previous: 'Назад',
    Next: 'Далі',
    Loading: 'Завантаження…',
    Total: 'Разом',
    Details: 'Деталі',
  },
  dayoff: {
    select_title: 'Оберіть свої вихідні',
    selection_hint: 'Клік по дню · тягніть, щоб вибрати діапазон',
    today: 'Сьогодні',
    days_selected: 'дн. обрано',
    selected_days: 'Обрані дні',
    legend_selected: 'Обрано',
    legend_your: 'Ваш вихідний',
    legend_holiday: 'Святковий день',
    legend_mate: 'Колега відсутній',
    away_this_period: 'Відсутні в цей період',
    nobody_away: 'У цей період ніхто не відсутній',
    description: 'Опис',
    description_placeholder: 'напр. Відпустка, зайнятий день…',
    submit: 'Зберегти вихідні',
    saved: 'Вихідні збережено: {range} — {count} дн.',
    saved_empty: 'Усі вихідні видалено',
    you: 'ви',
    tip_holiday: 'Свято',
    tip_away: 'Відсутні',
    tip_out_count: 'Поза офісом: {count} ос.',
    tip_more: 'і ще {count}',
    days_count: '{count} дн.',
    tip_holiday_war: 'Не вихідний під час воєнного стану',
    on_dayoff_today: 'Сьогодні вихідний',
    gcal_title: 'Google Календар',
    gcal_connect: 'Підключити Google Календар',
    gcal_connected: 'Google Календар синхронізовано',
    gcal_disconnect: 'Відключити',
    history_title: 'Історія запитів',
    history_period: 'Період',
    history_days: 'Дні',
    history_note: 'Нотатка',
    history_added: 'Додано',
    history_empty: 'Ви ще не брали вихідних',
    history_requests: 'Запитів: {count}',
    history_used_year: 'Використано цього року: {count} дн.',
    days_short: '{count}д',
    unsaved_title: 'Незбережені вихідні',
    unsaved_message: 'Обрані дні та нотатку ще не збережено.',
    unsaved_keep: 'Продовжити редагування',
    unsaved_drop: 'Скасувати зміни',
    clear: 'Очистити',
  },
  board: {
    add_new_task: 'Створити завдання',
    add_stage: 'Додати стадію',
    add_column: 'Додати колонку',
    enter_stage_name: 'Введіть імʼя стадії',
    no_stages_title: 'Стадій ще немає',
    no_stages_text: 'Додайте першу стадію, щоб почати створювати завдання.',
    need_stage_to_create_task: 'Спершу додайте хоча б одну стадію до проекту, щоб створити завдання.',
    Enter_task_description: 'Введіть опис завдання',
    Delete_stage: 'Видалити стадію',
    sure_delete_stage: 'Ви впевнені, що хочете видалити цю стадію?',
    really_delete_stage: 'Ви дійсно бажаєте видалити стадію?',
    stage_also_leted: 'Всі завдання в стадії також будуть видалені!',
    CANCEL: 'Скасувати',
    YES: 'Так',
    we_send_invite: 'Ми надіслали запрошення на електронну пошту:',
    please_ask_user: 'Будь-ласка, попросіть користувача прийняти посилання, щоб приєднатися до вашого проекту',
    okay: 'Гаразд',
  },
  comments: {
    bot_line1: 'Чудово! Так ти можеш відкривати завдання.',
    bot_line2:
      'Як ти можеш бачити, твій час роботи над завданням вже враховється і відображається в правому нижньому кутку.',
    bot_line3: 'Тут ти можеш залишати повідомелення стосовно завдання або перетягати сюди файли',
    max_pins_reached: 'Дозволено максимум 5 закріплених коментарів',
    pin_comment: 'Закріпити коментар',
    pinned_comments: 'Закріплені коментарі',
    add_reaction: 'Додати реакцію',
  },
  notifications: {
    title: 'Сповіщення',
    mark_all_read: 'Позначити всі прочитаними',
    read_all: 'Прочитати всі',
    all_caught_up: 'Нових сповіщень немає',
    all_caught_up_hint: 'Тут з’являться згадки, запрошення та запити',
    added_you_to_project: 'додав(ла) вас до проєкту',
    open_project: 'Відкрити проєкт',
    rejected_invite_workspace: 'відхилено запрошення до цієї робочої зони',
    requested_to_add: 'запит на додавання',
    for: 'для',
    Task: 'Завдання',
    task_created: 'створена',
    task_deleted: 'видалена',
    task_transferred: 'перенесена',
    task_restored: 'відновлена',
    Restore: 'Відновити',
    image_deleted: 'Зображення видалено',
    NEW: 'НОВИЙ',
    Accept: 'Підтвердити',
    Reject: 'Відхилити',
    Accepted: 'Підтверджено',
    Rejected: 'Відхилено',
    Viewed: 'Переглянуто',
    Then_Deleted: 'Потім видалено',
    Then_Canceled: 'Потім відхилено',
    by: 'користувачем',
    notify_assigned: 'назнач. Вас на',
    mention_in_task: 'згадування в',
    mentioned_you_in_task: 'згадав(ла) вас у завданні',
    to_a_task: 'на завдання',
    new_assign: 'Призначив(ла) на вас завдання',
    offline_mode: 'Режим офлайн',
    no_new_version_found: 'Нову версію не знайдено',
    your_account_deleted: 'Ваш акаунт видалено',
    dayoff_title: 'Вихідний',
    dayoff_notice: 'у вихідному {dates}',
    dayoff_takes: 'бере вихідний',
    dayoff_is_off: '{name} бере вихідний',
    user_commented: '{name} коментує',
    user_assigned_you: '{name} призначає вас',
    open_task: 'Відкрити завдання',
    open_calendar: 'Відкрити календар',
    invoice_autogen_failed: 'Не вдалося автоматично згенерувати інвойс за {month}, шаблон',
    invoice_autogen_sent: 'Інвойс за {month} надіслано автоматично, шаблон',
    open_invoice_generator: 'Відкрити генератор інвойсів',
    dismiss: 'Приховати',
  },
  uploads: {
    not_uploaded: '{count} не завантажено',
    queued: 'У черзі',
    saving: 'Зберігаю',
    done: 'Готово',
    retry_attempt: 'Повтор {attempt} з {max}',
    offline: 'Чекаю мережу',
    failed: 'Не завантажено',
    retry: 'Повторити',
    remove: 'Прибрати',
    errors: {
      too_large: 'Більше за {limit}, не завантажено',
      not_uploaded: 'Файл не дійшов до сховища',
      storage_refused: 'Сховище відхилило файл',
      unreachable_storage: 'Не вдалося зʼєднатися зі сховищем',
      server_error: 'Сервер не зміг зберегти файл',
    },
  },
  system: {
    syncing: 'Синхронізація з хмарою',
    __resume_button: 'Продовжити',
    __ok_button: 'OK',
    __stop_button: 'Стоп',
    __hide_button: 'Приховати',
    __resume_last_task: 'Продовжити останнє завдання',
    __create_task_notify: 'Створити завдання',
    __not_tracking_title: 'Ви не трекаєте',
    __not_tracking_subtitle: 'вже 10 хвилин',
    __still_here_title: 'Ви ще тут?',
    __still_here_subtitle: 'Давно немає активності — трекінг зупиниться',
    __still_here_confirm: 'Я тут',
    __wait_install_app: 'Будь ласка, зачекайте. Встановлення трекліфая...',
    __accept_button: 'Погодитись',
    __reject_button: 'Відмінити',
    __mute_tomorrow: 'Вимкнути на сьогодні',
    __muted_title: 'Нагадування вимкнено',
    __muted_subtitle: 'до завтра',
    __undo: 'Скасувати',
    __timer_running: 'Таймер працює',
    __approve_tracked_time: 'Підтвердіть відстежений час',
    __no_estimate: 'Без оцінки',
    __not_tracking_label: 'Трекінг не йде',
    __until_tomorrow: 'До завтра',
    __no_activity_detected: 'Активності не виявлено',
    __open_app: 'Відкрити застосунок',
    __cancel: 'Відміна',
    __you_resume_tracking: 'Ви продовжуєте останнє завдання:',
    /* Main notify */
    __tracker_was_closed: 'Застосунок було закрито з активним завданням',
    __tracking_resume: 'Трекінг відновлено',
    __new_version_found: 'Знайдено нову версію',
    __new_version_found_but_error:
      'Знайдено нову версію, але на жаль ваша система не підтримує автоматичного оновлення',
    __new_version_download_button: 'Встановити',
    __later_button: 'Пізніше',
    __dismiss_button: 'Відклонити',
    __downloading_version: 'Встановлення нової версії',
    __install_button: 'Встановлення',
    __downloading_version_percent: 'Завантаження нової версії',
    __failed_download: 'Помилка завантаження нової версії',
    __try_again: 'Ще раз',
    __installing_new_version: 'Встановлення нової версії',
    __failed_install: 'Помилка встановлення нової версії',
    __failed_open_new_version:
      'Помилка відкриття нової версії. Будь ласка, закрийте застосунок  і відкрийте знову',
    __close_app: 'Закрити застосунок',
    __tracking_stopped: 'Трекінг зупинено: система простоює',
    __tricking_resume: 'Трекінг продовжено: активація системи',
    __tracking_stopped_shutdown: 'Трекінг зупинено: Комп’ютер вимикається',
    __tricking_resume_unlocked: 'Трекінг продовжено: екран разблоковано',
  },
  appRunner: {
    run_tracker: 'Мій трекер',
    not_installed: 'Не встановлений',
    started: 'Запущено',
    starting: 'Запускається',
    install_app_to_track: 'Встановіть застосунок на робочій стіл',
    instalattion_is_simple: 'Забудьте про діалог "Відкрийте доступ до екрану", отримуйте комфортні нотифікації завдяки застосунку Tracklify!',
    install_desktop: 'Встановіть застосунок Tracklify на робочій стіл для безперервного трекінгу',
    install_step1: 'Скачайте застосунок',
    install_step2: 'Запустіть завантажений файл',
    see_other_platforms: 'Подивитися версії для інших платформ',
    install_help: 'Відео допомога',
    done_button: 'Все встановслено, закрити',
    already_installed: 'Вже встановлено? Можна закрити цю сторінку.',
    download_app: 'Завантажити застосунок для Windows',
    download_app_deb: 'Завантажити для Ubuntu, Mint, інших Debian',
    download_app_rpm: 'Завантажити для Redhat, Fedora, інших RPM',
    download_app_pacman: 'Завантажити для Arch Linux та інших на основі Arch Linux',
    download_app_mac: 'Завантажити для macOS (Файл DMG)',
  },
  search: {
    search_or_navigate: 'Пошук та фільтри',
    hint: 'Введіть слово із завдання, імʼя учасника,<br> тег або назву проекту',
    nothing_found: 'Нічого не знайдено ¯\\_(ツ)_/¯',
    go_to: 'Перейти до',
    open: 'Відкрити',
    in: 'в',
    in_tasks: 'Шукати в завданнях:',
    invite: 'Запросити',
    invite_to_project: 'у робочу зону та проект',
    invite_user: 'Запросити',
    tasks_on: 'завдання на:',
    tasks_by: 'завдання від:',
    unassigned: 'Не призначена',
    noTag: 'Без тегів',
    clear_all: 'Очистити все',
    clear: 'Очистити',
    tagged: 'відмічено',
    show_all_tags: 'Показати всі теги',
    on: 'на',
    by: 'від',
    sign_up_not_confirmed: 'Реєстрація в робочій зоні не підтверджена',
  },
  menu: {
    Pause: 'Пауза',
    PauseUntilWindowActivation: 'Пауза до активації вікна',
    PauseFor5Minutes: 'Пауза на 5 хвилин',
    PauseFor10Minutes: 'Пауза на 10 хвилин',
    Resume: 'Старт',
    myTasks: 'Мої завдання',
    nav_menu: 'Меню',
    nav_tasks: 'Завдання',
    nav_alerts: 'Сповіщення',
    nav_me: 'Я',
    task_history: 'Історія завдань',
    view_all_task_history: 'Уся історія завдань',
    __open_logs: 'Відкрити журнали',
    __check_updates: 'Перевірити оновлення',
    __enable_window_titles: 'Увімкнути заголовки вікон',
    __devtools: 'DevTools',
    __quit: 'вийти з додатку',
    download_app: 'Завантажити трекер',
    summary_report: 'Загальний звіт',
    dayoff: 'Вихідні',
    time_reports: 'Докладні звіти',
    projects: 'Проекти',
    my_screenshots: 'Мої скріншоти',
    create_project: 'Створити новий проект',
    project_settings: 'Налаштування проекту',
    ai_assistant: 'ШІ-асистент',
    profile: 'Профіль',
    dark_mode: 'Темна тема',
    salary: 'Зарплата',
    profit_share: 'Profit-share',
    logout: 'Вийти',
    get_help: 'Отримати допомогу',
    about: 'Про Трекліфай',
    ai_automation: 'AI та автоматизація',
    workspace: 'Робоча зона',
    switch_workspace: 'Змінити робочу зону',
    workspace_settings: 'Налаштування робочої зони',
    create_new_workspace: 'Нова робоча зона',
    workspace_name: "Назва робочої зони",
    personal_workspace: "Особиста робоча зона",
    create_workspace: "Створити",
    create_workspace_failed: "Не вдалося створити робочу зону, спробуйте ще раз",
    invite_to_project: 'Запросити користувача до проекту',
    already_member_project: 'Користувач уже є членом проекту',
    resend_invite_button: 'НАДІСЛАТИ ПОВТОРНО',
    no_users_found: 'Користувача не знайдено, введіть e-mail для запрошення',
    invite_failed: 'Не вдалося запросити {email}: перевірте адресу',
    settings: '— опції',
    Project_name: 'Назва проєкту',
    task_short_id: 'Короткий іден-р завдання',
    Task_ID_example: 'Наприклад',
    already_taken: 'Вже використано у робочій зоні',
    Please_change: 'Будь ласка, змініть',
    Prefix: 'Префікс',
    Template: 'Правила',
    Project_background: 'Фон проекту',
    change: 'ЗМІНИТИ',
    create: 'СТВОРИТИ',
    Select_a_picture: 'Виберіть фон проекту',
    Examples: 'Наприклад:',
    pick_a_color: 'або оберіть колір',
    create_project_hint: 'Назвіть його, оберіть шаблон колонок і фон.',
    Search_pictures: 'Пошук зображень — абстракція, градієнт, вогні…',
    Create_project: 'Створити проєкт',
    Resend_invite: 'Повторно надіслати запрошення до проекту та робочого простору для',
    user_invite: 'Натисніть на користувача, щоб запросити',
    get_app: 'Заван-ти додаток',
    add_task: 'Додати',
    mentions_notify_1: 'У вас є',
    mentions_notify_2_single: 'завдання зі згадкою',
    mentions_notify_2_multy: 'завдання зі згадкою',
    task_create: 'Створити завдання',
    notifications: 'Сповіщення',
    no_new_notifications: 'Немає нових сповіщеннь',
    new_notification: 'нове',
    new_notifications: 'нових',
  },
  reports: {
    executors: 'Виконавці',
    now_working: 'Прямо зараз працюють',
    no_active_tasks: 'Ніхто не працює',
    work_one_day: 'Робота за один день',
    today: 'Сьогодні',
    work_this_month: 'Робота цього місяця',
    member: 'Учасник',
    activity: 'Активність',
    total: 'Усього',
    no_time_tracked: 'Поки що немає затреканого часу',
    no_time_tracked_this_month: 'Поки що немає затреканого часу цього місяця',
    date_range: 'Період часу',
    select_date_range: 'Оберіть період часу',
    show_filters: 'Показати фільтри',
    hide_filters: 'Сховати фільтри',
    filter_projects: 'Включити проєкти',
    select_projects: 'Оберіть проєкти',
    filter_labels: 'Тільки завдання з тегами',
    filter_exclude_labels: 'Виключити завдання з тегами',
    select_label: 'Оберіть тег',
    filter_executors: 'Увімкнути виконавців',
    select_executors: 'Обрати виконавців',
    group_by: 'Групувати за',
    group_projects: 'Проєктам',
    by_weeks: 'За тижнями',
    by_month: 'За місяцями',
    dont_group: 'Ні за чим',
    no_tasks: 'Не знайдено завдань за цим запитом',
    total_time: 'Загальний час',
    total_time_by_day: 'Загальний час по дням',
    burnup_chart: 'Графік зростання годин',
    all_spent: 'Всього<br/>витрачено',
    time_by_task: 'Час витрачений на завдання за період',
    invoice: 'Створити рахунок',
    roles: 'Ролям',
    search: 'Пошук',
    select_all: 'Обрати все',
    unselect_all: 'Очистити вибір',
    now: 'зараз',
    Enter_project_name: 'Введіть імʼя проекту',
    screenshots: 'Скріншоти',
    empty: 'Порожньо',
    screenshots_empty_title: 'Немає скріншотів',
    screenshots_empty_hint: 'За вибрані дати й фільтри нічого не знято.',
    time_empty_title: 'Немає відстеженого часу',
    time_empty_hint: 'За вибрані дати й фільтри нічого не відстежено.',
    last_month: 'Останній місяц',
    this_month: 'Цей місяць',
    this_year: 'Цей рік',
    all_time: 'За весь час',
    Ok: 'Ок',
    YES: 'ТАК',
    CANCEL: 'ВІДМІНА',
    Cancel: 'Відміна',
    Tasks: 'Завдання',
    Time: 'Час',
    Tasks_details: 'Деталі завдань',
    enter_variables_values: 'Введіть значення змінних',
    are_you_sure_delete_template: 'Ви впевнені, що хочете видалити шаблон?',
    are_you_sure_new_template: 'Ви впевнені, що хочете зберегти цей шаблон?',
    Template: 'Шаблон',
    Select_template: 'Виберіть шаблон',
    New_template_name: 'Нова назва шаблону',
    DOWNLOAD_PDF: 'ЗАВАНТАЖИТИ PDF',
    basic_example: 'Базовий приклад',
    worker_salary: 'Зарплата робітника',
    devforth_salary: 'Зарплата Devforth',
    executor: 'Виконавець',
    created: 'Дата створення',
    contributors: 'Учасники',
    value: 'Значення',
    progress: 'Прогрес',
    accuracy: 'Точність',
    spent_by: 'Витрачено',
    by_executor: 'виконавцем',
    total_spent_by: 'Всього витрачено',
    by_contributors: 'учасниками',
    export: 'Експорт',
    configure_columns: 'Налаштувати колонки',
    more_actions: 'Більше дій',
    round_hours_to: 'Округлити години до',
    export_to_csv: 'Експорт у CSV',
    export_to_gsheets: 'Експорт у Google Sheets',
  },
  placeholders: {
    e_g: 'Наприклад, Новий проєкт',
    Type_anything: 'пошук',
  },
  settings: {
    configure: 'Налаштування проєкту',
    delete_project: 'Видалити проєкт',
    Can_not_be_empty: 'Не може бути порожнім',
    New_prefix: 'Префікс',
    Save: 'Зберегти',
    Cancel: 'Скасувати',
    general: 'Загальне',
    Labels: 'Теги',
    Members: 'Учасники',
    Tracker_Rules: 'Кнопки потоку',
    Notifications: 'Сповіщення',
    notification_settings_title: 'Сповіщення проєкту',
    notify_member_dayoff: 'Сповіщати мене, коли учасник проєкту бере вихідний',
    Stages: 'Стадії',
    No_labels_yet: 'Тегів поки немає',
    Admin: 'Адміністратор',
    Not_a_member: 'не учасник',
    Member: 'Учасник',
    Role_on_project: 'Роль у проєкті',
    Actions: 'Дії',
    Permissions: 'Права',
    Other: 'Інша',
    Invite_member: 'Запросити',
    exclude_the_user: 'Ви впевнені, що бажаєте виключити користувача з проєкту?',
    Exclude: 'Виключити',
    Configure_workspace: 'Налаштування робочої зони',
    Workspace_name: 'Імʼя робочої зони',
    Logo: 'Лого',
    Workspace_UI_language: 'Мова інтерфейсу робочої зони',
    Workspace_alias: 'Базовий URL зони',
    General: 'Загальне',
    Priorities: 'Пріоритети',
    Edit_tag_name: "Змінити ім'я тега:",
    Pick_a_color: 'Виберіть колір',
    DELETE_TAG: 'ВИДАЛИТИ ТЕГ',
    ARCHIVE_TAG: 'АРХІВУВАТИ ТЕГ',
    UNARCHIVE_TAG: 'РОЗАРХІВУВАТИ ТЕГ',
    TASKS: 'ЗАД.',
    EDIT: 'Змінити',
    confirm_delete: 'Ви впевнені, що бажаєте видалити проєкт?',
    archive: 'Архівувати | архівувати | Архів',
    unarchive: 'Розархівувати | розархівувати',
    confirm_archive: 'Ви впевнені, що бажаєте {action} проєкт?',
    cant_undone: 'Це неможливо скасувати',
    confirm_user_deletion: 'Ви впевнені що хочете видалити користувача?',
    CANCEL: 'ВІДМІНИТИ',
    YES: 'ТАК',
    Yes: 'Так',
    delete: 'Видалити',
    only_admin_can_delete_user: 'Тільки адміністратор робочої зони може видаляти її членів',
    only_admin_can_change_language: 'Тільки адміністратор робочої зони може змінити мову',
    ADMIN: 'АДМІНІСТРАТОР',
    MEMBER: 'УЧАСНИК',
    GUEST: 'ГІСТЬ',
    FINANCE: 'ФІНАНСИСТ',
    admin_description: 'Має повний доступ',
    member_description: 'Має доступ тільки до проектів, куди його запросили, але може бачити звіти часу для всіх членів і всіх проектів. Може бачити назви завданнь чужих проектів.',
    guest_description: 'Має доступ тільки до проектів, куди його запросили, бачить звіти часу для всіх членів доступних проектів.',
    doScreenshots: 'Робити скрінштоти для підтвердження роботи',
    single_admin_role_warning: 'Ви не можете змінювати прав для єдиного адміністратора',
    owner_role_warning: 'Ви не можете змінювати права власника робочої зони',
  },
  workspaceSettings: {
    general_subtitle: 'Назва воркспейсу, логотип, мова та фірмовий колір',
    members_subtitle: 'Люди у воркспейсі та їхні ролі',
    priorities_subtitle: 'Порядок проєктів у «Моїх завданнях» кожного учасника',
    name_saved: 'Назву воркспейсу збережено',
    logo_saved: 'Логотип воркспейсу збережено',
    timezone_saved: 'Основний часовий пояс збережено',
    brand_color: 'Фірмовий колір',
    main_timezone: 'Основний часовий пояс',
    search_timezone: 'Пошук часового поясу',
    language: 'Мова',
    role: 'Роль',
    admins: 'Адміністратори',
    pending_invites: 'Очікують на прийняття',
    name_hint: 'Показується в перемикачі воркспейсів і в запрошеннях.',
    language_hint: 'Типова мова для всіх у воркспейсі.',
    brand_color_hint: 'Використовується у звітах, експортованих у Google Sheets.',
    timezone_hint: 'Звіти про час і рахунки рахують дні в цьому часовому поясі. Змінити його можуть лише власник та адміністратори.',
  },
  projectSettings: {
    group_project: 'Проєкт',
    group_people: 'Люди',
    group_automation: 'Автоматизація',
    integrations: 'Інтеграції',
    general_subtitle: 'Назва й вигляд проєкту',
    tags_subtitle: 'Мітки для категоризації задач на цій дошці',
    stages_subtitle: 'Колонки дошки — змініть порядок, щоб змінити флоу',
    members_subtitle: 'Люди з доступом до проєкту та їхні ролі',
    flow_subtitle: 'Дії великих флоу-кнопок на сторінці задачі, для кожної стадії',
    integrations_subtitle: 'Підключені сервіси, що звітують у Tracklify',
    tasks_total: 'Усього задач',
    name_hint: 'Показується в сайдбарі, хедері дошки та в кожному посиланні на задачу.',
    background: 'Фон дошки',
    background_hint: 'Зображення за колонками дошки. Приглушене, щоб картки лишались читабельними.',
    no_background: 'Без фону',
    photo_by: 'Фото:',
    screenshots_hint: 'Скриншоти під час роботи таймера, прив’язані до відстеженого часу.',
    enabled: 'Увімкнено',
    disabled: 'Вимкнено',
    change: 'Змінити',
    archive_title: 'Архівувати проєкт',
    archive_hint: 'Ховає його із сайдбару та перемикача дощок. Відстежений час лишається у звітах — відновити можна будь-коли.',
    archive_button: 'Архівувати',
    unarchive_title: 'Відновити проєкт',
    unarchive_hint: 'Повертає його в сайдбар і перемикач дощок.',
    unarchive_button: 'Розархівувати',
    delete_title: 'Видалити проєкт',
    delete_hint: 'Видаляє проєкт разом із задачами.',
    tag: 'Тег',
    used_on: 'Використано',
    tasks_count: '{count} задач',
    edit: 'Змінити',
    archived: 'В архіві',
    archive: 'Архівувати',
    unarchive: 'Розархівувати',
    add_tag: 'Додати тег',
    new_tag: 'Новий тег',
    tag_name: 'Назва тегу',
    create: 'Створити',
    stage: 'Стадія',
    tasks: 'Задачі',
    order: 'Порядок',
    add_stage: 'Додати стадію',
    stage_name: 'Назва стадії',
    rename_stage: 'Перейменувати стадію',
    stage_name_hint: 'Показується як заголовок колонки на дошці.',
    to_save: 'щоб зберегти',
  },
  projectRules: {
    when_task_in_stage: 'Коли завдання на стадії',
    secondary_button: 'Другорядна кнопка (зліва)',
    primary_button: 'Головна кнопка',
    this_rule_willnot_work: 'Це правило не буде працювати',
    add_action: 'Додати дію',
    similar_item_was_used: 'аналогічний елемент уже використано',
    preview: 'Попередній перегляд',
    move: 'Відправити',
    move_to: 'Відправити в',
    assign: 'Назначити',
    assign_if_not_assigned: 'Назначити якщо не назначено',
    assign_mention: 'Назначити згаданого',
    unassign: 'Відмінити назначення',
    auto_click_after: 'Автоклік після',
    activate_button_if_user_mentioned_in_comment: 'Активувати кнопку, якщо користувач згаданий (@) в коментарії',
    auto_click_after_tracked_1: 'Автоклік після',
    auto_click_after_tracked_2: 'трекінгу',
    minutes: 'хв',
    Me: 'Себе',
    Task_creator: 'Автора завдання',
    no_buttons: 'Кнопки не показуються',
  },
  task: {
    edited: 'змінено',
    nowin: 'Зараз в',
    ago: 'назад',
    by: '',
    add: 'додати',
    Tags: 'Теги',
    Actions: 'Дія',
    noDescription: 'Поки без опису',
    timeSpent: 'Витрачено часу',
    ADD_A_CHECKLIST: 'Додати пункти',
    ADD_A_CHECKLIST_ITEM: 'Додати пункт',
    Created_task_in: 'Створено завдання в ',
    Assigned: 'Призначено виконавця',
    Changed_task_description: 'Змінено опис завдання',
    Transferred_task_from: 'Перенесено завдання з',
    Type_comment: 'Коментар',
    SET_EST: 'Оц. завд.',
    SET_ESTIMATE: 'Оцінити завдання',
    Clear: 'Зтерти',
    STORY_POINTS: 'Сторі поїнти',
    Estimate: 'Оцінка',
    Progress: 'Прогрес',
    Add_time: 'Додати час',
    est: 'оц.',
    Code_block: 'Блок коду',
    List: 'Список',
    Video: 'Відео',
    USUAL: 'ЗВИЧ.',
    PRIO: 'Пріорітет',
    Set_estimate_to: 'Оцінив(ла) завдання',
    Set_priority: 'Встановив(ла) пріоритет',
    Delete_task: 'Видалити завдання',
    Screenshots: 'Скрінштоти',
    Add_manual_time: 'Додати час',
    Add_to_liked: 'Додати в вподобання',
    CANCEL: 'Скасувати',
    YES: 'Так',
    Back_to_task: 'Повернутись до завдання',
    What_were_you_doing: 'Над чим ви працювали?',
    manual_how_long: 'Скільки часу?',
    manual_set_exactly: 'або вкажіть точно',
    manual_description_placeholder: 'напр. Дзвінок з клієнтом щодо планів на Q4',
    manual_request: 'Запросити {duration}',
    manual_pick_hint: 'Проведіть по шкалі, щоб обрати, коли ви працювали',
    manual_tab_range: 'Проміжок',
    manual_tab_duration: 'Тривалість',
    manual_today: 'Сьогодні',
    manual_earlier: 'Раніше',
    manual_later: 'Пізніше',
    manual_legend_tracked: 'Відстежено',
    manual_legend_request: 'Цей запит',
    manual_time_admin_required: 'Ручний час перевіряє адмін воркспейсу, а в цьому проєкті його немає. Додайте адміна до проєкту:',
    manual_time_request_refused: 'Ручний час не запитано. Оновіть сторінку й спробуйте ще раз.',
    manual_time_update_refused: 'Ручний час не оновлено: його вже опрацювали або у вас більше немає доступу. Оновіть сторінку, щоб побачити поточний стан.',
    Type_item: 'Опишіть пункт',
    to_normal: 'звичайний',
    ASSIGN: 'На кому',
    SEARCH_ASSIGNEE: 'Пошук виконавця',
    Unassign: 'Не призн.',
    just_now: 'щойно',
    Removed_assignee: 'Видалив(лa) виконавця',
    Moved_to: 'Пересунув(лa) в',
    Added_tag: 'Додав(ла) тег',
    Removed_tag: 'Видалив(лa) тег',
    Added: 'Додав(лa)',
    Reqested_to_add: 'Запит на додавання',
    Approved: 'Підтвердив(ла)',
    Rejected: 'Відмовив(ла)',
    Canceled: 'Скасував(ла)',
    Deleted: 'Видалив(ла)',
    by_trigger: 'по тригеру',
    REMOVE: 'Видалити',
    Are_you_sure: 'Ви впевнені?',
    Are_you_sure_you_want_to_delete_this_image: 'Ви впевнені, що хочете видалити це зображення?',
    set_as_task_preview: 'Зробити прев\'ю завдання',
    max_images_reached: 'Можна завантажити не більше {limit} зображень за раз',
    current_task_preview: 'Поточне прев\'ю завдання',
    next_image: 'Наступне зображення',
    previous_image: 'Попереднє зображення',
    Are_you_sure_you_want_to_delete_this_comment: 'Ви впевнені, що хочете видалити цей коментар?',
    Are_you_sure_you_want_to_delete_this_checklist_item: 'Ви впевнені, що хочете видалити цей пункт чекліста?',
    Delete: 'Видалити',
    Yes: 'Так',
    No: 'Ні',
    manual_CANCEL: 'Скасувати',
    manual_Remove: 'Видалити',
    manual_YES: 'Так',
    delete_screenshot_title: 'Видалити цей скріншот?',
    delete_screenshot_subtitle: 'Цю дію не можна скасувати',
    Add_tags: 'Додати тег',
    create_new_tag: 'Створити новий тег',
    search_or_create_tag: 'Знайти або створити тег...',
    No_screenshots_here_enable: 'Покищо тут немає скріншотів, продовжуйте трекати час доки вони не з’являться',
    No_screenshots_here_disable: 'Скріншоти для цього проекту вимкнено',
    No_screenshots_here_disable_admin_part1: 'Скріншоти для цього проекту вимкнено. Відкрийте ',
    No_screenshots_here_disable_admin_part2: 'налаштування',
    No_screenshots_here_disable_admin_part3: ', щоб змінити їх',
    SPENT: 'Витрачено',
    oops: 'Упс!',
    cannot_find_page: 'Ми не можемо знайти сторінку, яку ви шукаєте',
    start_from_home: 'На головну сторінку',
    nf_title: 'Тут нічого немає.',
    nf_subtitle: 'Сторінки, яку ви запросили, не існує. Перевірте URL або поверніться до знайомого місця.',
    go_to_homepage: 'На головну сторінку',
    go_back: 'Назад',
    spent_time: 'Витрачено часу',
    copy_to_clipboard: 'Скопіювати до буферу обміну',
    copied_to_clipboard: 'Посилання скопійоване до буферу обміну',
    copy_video_link: 'Копіювати посилання',
    volume: 'Гучність',
    converting_video: 'Конвертується…',
    picture_in_picture: 'Картинка в картинці',
    expand_video: 'Збільшити',
    collapse_video: 'Зменшити',
    we_are_still_processing_video: 'Ми все ще обробляємо відео',
    video_available_not_for_all_platforms: 'Відео поки що недоступне для платформ, які не підтримують WebM. Ми виконуємо додаткову конвертацію в MP4. Будь ласка, зачекайте.',
    move_to: 'Відправити в',
    unassign: 'Відкріпити',
    assign: 'Призначити',
    unable_to_restore_image: 'Неможливо відновити зображення.',
    Record_screen: 'Запис екрану',
    screenshot_activity: 'Активність',
    my_last_screenshots: 'Мої останні скріншоти',
    view_all: 'Переглянути всі',
    Executor: 'Виконавець',
    edit: 'змінити',
    Stage: 'Стадія',
    NoStage: 'Без стадії',
    PriorityLow: 'Низький',
    PriorityUsual: 'Звичайний',
    PriorityHigh: 'Високий',
    PriorityUrgent: 'Терміновий',
    PrioritySuperUrgent: 'Дуже терміновий',
    Unset: 'Не задано',
    Change_project: 'Перенести завдання',
    Please_select_project_to_move: 'Будь ласка, оберіть проєкт для перенесення',
    No_transfer_available: 'Перенесення недоступне',
    Created_by: 'Створив(ла)',
    transfer_unavailable: {
      not_creator: 'Переносити може лише автор, а ви не автор',
      single_project: 'Є лише один проєкт — переносити нікуди',
      child_task: 'Неможливо перенести окреме підзавдання',
    },
    are_you_sure_transfer_task: 'Ви впевнені, що хочете перенести це завдання?',
    time_save_but_screenshots_unavailable: 'Знімки екрана і відстежуваний час будуть збережені, але недоступні для перегляду в перенесеному завданні.',
    screenshots_from_tracked_time: 'Знімки екрана за відстежуваний час',
  },
  theme: {
    title: 'Тема',
    dark: 'Темна',
    light: 'Світла',
    pink: 'Рожева',
    violet: 'Фіолетова',
    lime: 'Салатова',
  },
  themeEditor: {
    new_theme: 'Нова тема',
    new_title: 'Нова тема',
    edit_title: 'Редагувати тему',
    unsaved_message: 'Зміни в темі ще не збережено.',
    name: 'Назва',
    name_placeholder: 'Моя тема',
    mode: 'Режим',
    colors: 'Кольори',
    seed_base: 'Фон',
    seed_ink: 'Текст',
    seed_accent: 'Акцент',
    fine_tune: 'Тонке налаштування',
    overrides_hint: 'Необов\'язково. Порожні кольори слідують кольорам вище.',
    token_bg2: 'Панелі',
    token_control: 'Кнопки',
    token_card: 'Картки',
    token_chrome: 'Верхня панель',
    token_line: 'Межі',
    'token_text-muted': 'Другорядний текст',
    'token_accent-soft': 'Відтінок акценту',
    token_red: 'Червоний',
    token_green: 'Зелений',
    token_blue: 'Синій',
    reset: 'Скинути',
    share: 'Поділитися з простором',
    share_hint: 'Учасники {workspace} теж зможуть її обрати',
    shared: 'Доступна простору',
    shared_by: 'Поділився {name}',
    delete: 'Видалити',
    delete_title: 'Видалити тему?',
    cancel: 'Скасувати',
    save: 'Зберегти',
    preview: 'Попередній перегляд',
    preview_project: 'Редизайн сайту',
    preview_search: 'Пошук',
    preview_filters: 'Фільтри',
    preview_filter_mine: 'Мої задачі',
    preview_filter_tagged: 'З тегами',
    preview_filter_tracked: 'Відстежено сьогодні',
    preview_todo: 'До виконання',
    preview_doing: 'В роботі',
    preview_done: 'Готово',
    preview_card_onboarding: 'Екрани онбордингу',
    preview_card_ora: 'Обмежити спам ORA ORA ORA в коментарях',
    preview_card_invoices: 'Щомісячні рахунки',
    preview_card_icons: 'Новий набір іконок',
    preview_card_clash_royale: 'Nerf Mega Knight',
    preview_tag_bug: 'Баг',
    preview_tag_design: 'Дизайн',
    preview_tag_release: 'Реліз',
  },
  profile: {
    password_title: 'Зробіть його важким для вгадування',
    password_hint: 'Вимоги підсвічуються, доки ви вводите.',
    rule_length: '{count} або більше символів',
    rule_number: 'Щонайменше одна цифра',
    rule_uppercase: 'Велика літера',
    rule_match: 'Паролі збігаються',
    rule_no_spaces: 'Без пробілів',
    rule_different: 'Відрізняється від поточного пароля',
    save_password: 'Зберегти пароль',
    username_required: 'Ім\'я не може бути порожнім',
    profile_saved: 'Профіль збережено',
    username_invalid: "Ім'я може містити лише літери, цифри, пробіли та . , - _ ' ’ & ( ) {'@'} +",
    profile_save_failed: "Не вдалося зберегти профіль, спробуйте ще раз",
    password_changed: 'Пароль змінено',
    delete_title: 'Видалити ваш акаунт?',
    will_be_removed: 'Буде видалено',
    removed_profile: 'Профіль, фото та налаштування',
    removed_access: 'Доступ до всіх робочих просторів і проєктів',
    removed_settings: 'Вихідні та особисті налаштування',
    type_delete_prefix: 'Введіть',
    type_delete_suffix: 'для підтвердження',
    keep_account: 'Залишити акаунт',
    delete_forever: 'Видалити назавжди',
    subtitle: 'Дані вашого облікового запису та налаштування',
    section_photo: 'Фото профілю',
    section_personal: 'Особиста інформація',
    section_appearance: 'Вигляд',
    section_security: 'Безпека',
    section_danger: 'Небезпечна зона',
    upload_new: 'Завантажити нове',
    photo_hint: 'PNG або JPG, до 5 МБ',
    name_hint: 'Видно вашим колегам у задачах і коментарях',
    theme_hint: 'Застосовується до всіх ваших робочих просторів і пристроїв Tracklify',
    change_password: 'Змінити пароль',
    delete_account_hint: 'Назавжди видаляє ваш обліковий запис і всі особисті дані. Це неможливо скасувати.',
    delete_account_button: 'Видалити акаунт',
    Cancel: 'Скасувати',
    old_password_placeholder: 'Введіть поточний пароль',
    new_password_placeholder: 'Щонайменше {count} символів',
    repeat_password_placeholder: 'Повторіть новий пароль',
    days_off_visibility_hint: 'Оберіть, хто бачить, коли вас немає на ваших проєктах',
    days_off_everyone: 'Усі',
    days_off_members_only: 'Лише учасники',
    unsaved_changes: 'У вас є незбережені зміни',
    Configure_user_profile: 'Налаштування профілю',
    General: 'Загальні',
    Privacy: 'Конфіденційність',
    days_off_visibility_title: 'Хто може бачити мої вихідні?',
    days_off_visible_to_everyone: 'Усі учасники моїх проєктів, включно з гостями робочого простору',
    days_off_hidden_from_guests: 'Лише учасники й адміністратори робочого простору в моїх проєктах',
    Name_Surname: 'Імʼя & Прізвище',
    Avatar: 'Аватар',
    Email: 'E-мейл',
    CHANGE_PASSWORD: 'Змінити пароль',
    DELETE_ACCOUNT: 'Видалити аккаунт',
    Old_password: 'Старий пароль',
    New_password: 'Новий пароль',
    Repeat_new_password: 'Повторіть новий пароль',
    CANCEL: 'Скасувати',
    Fill_this_field: 'Заповніть це поле',
    Old_password_is_incorrect: 'Старий пароль неправильний',
    Password_must_be_same: 'Паролі мають бути однаковими',
    Change_user_password: 'Зміна пароля користувача',
    Password_must_be_at_least: 'Пароль повинен бути не меншим',
    characters: 'символів',
    destroy_your_account: 'Це знищить ваш обліковий запис користувача',
    type_delete_to_confirm: 'Введіть DELETE, якщо ви впевнені',
    delete_me: 'ВИДАЛИТИ МЕНЕ',
  },
  time: {
    M: 'Х',
    S: 'С',
    d: 'д',
    w: 'т',
    y: 'р',
    H: 'Г',
  },
  button: {
    Yes: 'Так',
  },
  recording: {
    Record_your_screen: 'Запишіть свій екран',
    Record_Microphone: 'Запис мікрофону',
    Record_Webcam: 'Запис Веб-камери',
    cant_start_rec: 'Не вдалося розпочати запис екрана, ви вибрали екран? Помилка',
    Cant_start_camera: 'Неможливо почати запис з камери, ви дали дозвіл? Помилка',
    Webcamera_preview: 'Попередній перегляд',
    Start_recording: 'Почати запис',
    recording_screen_now: 'Зараз ви записуєте свій екран',
    Stop_recording: 'Зупинити запис',
  },
  loader: {
    Loading: 'Завантаження',
  },
  rule: {
    When: 'Коли',
    Else: 'Ще',
    Action: 'Дія',
    Condition: 'Стан',
  },
  trackTimeBar: {
    Unassign: 'Не призн.',
  },
  downloadMobile: {
    Get_Tracklify_mobile: 'Завантажте мобільний застосунок Tracklify',
    Browse: 'Переглядайте,',
    discuss_your_tasks: 'обговорюйте свої завдання, керуйте командою на мобільному телефоні або',
    quickly_creates_tasks: 'швидко створюйте завдання із загальних скріншотів',
    You_have_Tracklify: 'У вас вже є застосунок Tracklify на вашому смартфоні',
    Reports: 'Звіти',
  },
  title: {
    select_text_and: 'оберіть текст та ctrl + l',
  },
  trackingNotice: {
    __tracking_going: 'Tracklify збирається зробити скріншоти, щоб довести що ви працювали',
    __please_share: 'Будь ласка, діліться всім екраном, щоб ми могли його відстежувати',
    __choose_entire_screen: 'У вікні браузера оберіть «Весь екран», потім натисніть «Поділитися»',
    __window_or_tab_wont_work: 'Доступ до окремого вікна або вкладки Chrome не спрацює',
    __tracking_makes_screenshots:
      'Tracklify робить лише один знімок екрана за 10 хвилин з невеликими випадковими змінами часу',
    __screenshots_securely:
      'Скріншоти безпечно зберігаються у хмарному сховищі, їх можна завжди переглядати і видалити (з втратою часу)',
    __press_cancel: 'Будь ласка, натисніть кнопку Скасувати, якщо ви не бажаєте відстежувати час',
    __good_try: 'Гарна спроба!',
    __selected_one: 'Але ти вибрав',
    __selected_two: 'замість всього екрана',
    __canceled_sharing: 'Ви скасували відстеження екрану',
    __unfortunately: 'На жаль, ми не зможемо відстежити ваш час',
    __you_ws_admin: 'Оскільки ви є адміністратором робочого простору, ви можете:',
    __we_will_notify: 'Ми сповістимо вас про те, коли знімок був зроблено або стеження зупиненно',
    __please_notify: 'будь ласка, дозволяйте сповіщення',
    __notifications_only: 'Tracklify використовує сповіщення лише для інформування зміни стану',

    __we_recommended_notifications: 'Радимо також перевірити, чи увімкнено сповіщення браузера в налаштуваннях ОС',
    __we_recommended_idle:
      'Радимо дозволити доступ до інформації про використання пристрою',


    __we_will_idle: 'Ми перевіримо коли ви не працюєте',
    __needs_device_use:
      'Tracklify використовує дозвіл "використання пристрою" щоб автоматично припиняти відстеження, коли ви залишаєте комп\'ютер довше, ніж на 10 хвилин.',
    __provide_better:
      'Цей параметр використовується лише для забезпечення кращого відстеження, ніякі дані про користувача не збираються',
    __well_done: 'Добре',
    __we_recommended_hide_popup: 'Рекомендуємо сховати вікно щоб не заважало',
    __just_press: 'Просто натисність щоб приховати:',
    __to_leave:
      'Щоб зупинити роботу і припинити стеження, будь ласка, закрийте вкладку Trackclif в браузері',
    __sorry_we_cant: 'Вибачте, але ми не можемо почати відстежувати',
    __we_dont_have_perm: 'У нас немає дозволу на доступ до вашої активності. Будь ласка, скиньте всі дозволи щоб браузер запитав їх знову.',
    __try_again_btn: 'Спробувати ще',
    __dont_track: 'Гаразд, не стежити за годинами в цей раз',
    __enable_without: 'Увімкнути стеження за часом без знімків екрана для проекту',
    __dont_show_again: 'Не показувати знову',
    __close: 'Закрити',
    andReload: 'І потім оновіть сторінку',
    __choose_chrome_browser: 'Оскільки Трекліфай використовує прогресивний і сучасний IDLE detection API,<br>він може повноцінно працювати лише в браузері Chrome (або заснованому на Chrome)',
    __otherwise: 'Інакше ви можете завантажити десктопний застосунок:',
    __download: 'Скачать',
    __update_tracker: 'Оновити',
    __installing_update: 'Встановлення…',
    __update_failed: 'Не вдалося оновити. Натисніть «Оновити», щоб спробувати ще раз.',
    __you_can_disable_screenshots: 'Оскільки Ви є творцем проекту, Ви можете вимкнути створення скріншотів у',
    __project_settings: 'налаштуваннях проекту',
  },
  combobox: {
    nothing_found: 'Нічого не знайдено',
    create_hint: 'Натисніть Enter, щоб додати «{query}»',
    clear: 'Очистити',
  },
  taskFilters: {
    filter: 'Фільтр',
    title: 'Фільтри',
    applyFilters: 'Застосувати фільтри',
    show_more: 'Показати більше',
    hide: 'Сховати',
    createdTime: 'Дата створення',
    today: 'Сьогодні',
    yesterday: 'Вчора',
    assignee: 'Призначена на',
    executor: 'Виконавець',
    createdBy: 'Створена ким',
    tags: 'Теги',
    withTags: 'З тегами',
    avgUserVelocityPerDay: 'Середн. час користувача за день',
    userAlreadyTrackedTimeByTag: 'Затреканий час по тегу',
    estimation: 'Оцінка',
    inTotal: 'Загалом:',
  },
  projectPriorities: {
    title: 'Порядок проєктів',
    hint: 'Перетягуйте проєкти, щоб задати порядок їхніх груп у «Моїх завданнях». Термінові завдання завжди зверху, низькопріоритетні — внизу.',
    empty: 'Ще не учасник жодного проєкту',
    archived: 'В архіві',
  },
  taskHistory: {
    empty: 'Тут поки немає затреканих завдань',
    empty_hint: 'Запустіть таймер на завданні або змініть період і фільтри.',
    search: 'Пошук',
    period: 'Період',
    projects: 'Проєкти',
    stages: 'Стадії',
    search_placeholder: 'Пошук за назвою або номером',
    projects_placeholder: 'Усі проєкти',
    stages_placeholder: 'Усі стадії',
    all: 'Увесь час',
    today: 'Сьогодні',
    yesterday: 'Учора',
    last_week: 'Минулий тиждень',
    last_month: 'Минулий місяць',
    older: 'Раніше',
  },
  myTasks: {
    task_sorted_by_priority: 'Завдання за пріоритетом',
    mentions: 'Згадано',
    recents: 'Нещодавні',
    liked: 'Обране',
    total: 'сумарно',
    total_unreads: 'непрочитаних',
    total_updates: 'оновлень',
    no: 'немає',
    markAllAsRead: 'Позначити всі як прочитані',
    marking: 'Позначаю...',
    confirmMarkAllAsRead: 'Позначити всі згадування як прочитані?',
    confirmMarkAllAsReadMessage: 'Це позначить всі згадані завдання як прочитані. Цю дію неможливо скасувати.',
    openProject: 'Відкрити проєкт',
    open: 'Відкрити',
  },
  addTask: {
    project: 'Проєкт',
    search_projects: 'Пошук проєктів...',
    no_projects_found: 'Проєктів не знайдено',
    tags: 'Теги',
    no_tags: 'Немає тегів',
    search_tags: 'Пошук тегів...',
    nothing_found: 'Нічого не знайдено',
    create_tag: 'створити «{name}»',
    create_tag_hint: 'або натисніть enter',
    no_tags_hint: 'У цьому проєкті ще немає тегів.',
    create_task: 'Створити завдання',
    create_subtask_for: 'Створити підзавдання для {task}',
    placeholder: 'Введіть текст завдання тут',
    select_picture: 'Вибрати зображення',
    ctrl_v_paste: 'Ctrl+V, щоб вставити зображення з буфера обміну',
    tap_to_attach: 'Торкніться, щоб прикріпити зображення',
    or: 'або',
    select_exactly_image: 'Будь ласка, виберіть файл зображення',
  },
  invoiceAutoGen: {
    button: 'Автогенерація',
    save_template_first: 'Спершу збережіть шаблон',
    title: 'Автогенерація інвойсу',
    description: 'Генерується 1-го числа кожного місяця за попередній місяць із поточними фільтрами звіту.',
    active: 'Активна',
    off: 'Вимкнена',
    next_invoice_in: 'Наступний інвойс через {count} дн.',
    not_generated: 'Інвойси не генеруватимуться',
    turn_off: 'Вимкнути',
    save_failed: 'Не вдалося увімкнути автогенерацію: перевірте адреси',
    invoice_for: '{date} · інвойс за {month}',
    sent_to: 'Отримувачів: {count}',
    will_be_sent_to: 'Буде надіслано отримувачам: {count}',
    email: 'Email',
    additional_email: 'Додатковий email',
    additional_email_placeholder: "напр. accountant{'@'}company.com",
    initiated_by: 'Ініціатор:',
  },
  devtools: {
    title: 'AI та автоматизація',
    subtitle: 'Працюйте з Tracklify із термінала та з AI-асистентів для коду.',
    copy: 'Копіювати',
    regenerate: 'Оновити',
    cli: {
      terminal: 'tracklify — cli',
      title: 'Отримати Tracklify CLI',
      subtitle: 'Отримайте застосунок Tracklify CLI, щоб автоматизувати операції на кшталт git.',
      token_hint: 'Ваш токен особистий і секретний. Тримайте його в безпеці.',
      regenerate_title: 'Оновити токен CLI?',
      regenerate_subtitle: 'Усім авторизованим клієнтам доведеться увійти знову.',
      regenerated: 'Токен CLI оновлено',
      regenerate_failed: 'Не вдалося оновити токен CLI',
      branch_hint: 'Створити нову гілку для поточної задачі',
      branch_output: 'Створить гілку на кшталт feature/<projectname>/<taskHid>/<taskSlug>',
      commit_hint: 'Додати посилання на задачу в коміт',
      commit_output: 'Створить коміт на кшталт "my text <projectname>/<taskHid>/<taskSlug>"',
    },
    mcp: {
      terminal: 'tracklify — mcp',
      title: 'Отримати Tracklify MCP',
      subtitle: 'Підключіть MCP-клієнт до свого робочого простору Tracklify.',
      token_hint: 'Додайте цей заголовок зі своїм особистим токеном. Він дає доступ до Tracklify від вашого імені, тож тримайте його в секреті.',
      regenerate_title: 'Оновити токен MCP?',
      regenerate_subtitle: 'Клієнти з цим токеном втратять доступ. Застосунки, підключені через OAuth, працюватимуть далі.',
      regenerated: 'Токен MCP оновлено',
      regenerate_failed: 'Не вдалося оновити токен MCP',
      claude_code_step1: 'Виконайте в термміналі.',
      claude_code_step2: 'Потім виконайте в Claude Code, оберіть tracklify і натисніть Authenticate.',
      codex_step: 'Codex відкриє Tracklify у браузері для входу; якщо ні — виконайте codex mcp login tracklify.',
      antigravity_step: 'Додайте до ~/.gemini/config/mcp_config.json. Antigravity не має входу через OAuth для Tracklify, тож використовує ваш особистий токен.',
      other_step: 'Додайте цю URL до свого MCP-клієнта. З входом через OAuth він відкриє Tracklify у браузері, щоб спитати ваш дозвіл; інакше додайте заголовок нижче.',
      key: 'Ключ',
      value: 'Значення',
    },
    connections: {
      title: 'Підключені застосунки',
      empty: 'Через вхід OAuth ще не підключено жодного застосунку.',
      app: 'Застосунок',
      connected: 'Підключено',
      last_active: 'Остання активність',
      disconnect: 'Відключити',
      disconnect_failed: 'Не вдалося відключити застосунок',
    },
  },
  profitShare: {
    breadcrumb: 'Profit-share проєкт /',
    search_projects: 'Пошук Profit-share проєктів',
    author: 'Автор',
    no_accessible_projects: 'Немає доступних проєктів',
    confidential_badge: 'Конфіденційно · скріншоти розмиті',
    projects_stack: 'проєкти',
    members_stack: 'учасники',
    no_participating_projects: 'Немає проєктів-учасників',
    only_author_access: 'Наразі доступ має лише автор.',
    edit_project: 'Редагувати проєкт',
    create_project: 'Створити Profit-share проєкт',
    return_to_admin: 'Повернутися до режиму адміна',
    view_as_non_admin: 'Переглянути як не-адмін',
    loading_project: 'Завантаження Profit-share проєкту…',
    sections_aria: 'Розділи Profit-share',
    tab_overview: 'Огляд і дохід',
    tab_rates: 'Ставки учасників',
    tab_audit: 'Журнал аудиту',
    choose_title: 'Оберіть Profit-share проєкт',
    access_count: 'Доступних проєктів: {n}.',
    opening_shows: 'Відкритий проєкт показує конфіденційні дані про зарплати.',
    tracklify_projects_count: 'Проєктів Tracklify: {n}',
    members_count: 'Учасників: {n}',
    new_project: 'Новий проєкт',
    landing_kicker: 'Profit-share',
    landing_title: 'Прозоро розподіляйте прибуток між своїми проєктами',
    landing_text: 'Profit-share проєкт об\'єднує дохід і відстежені витрати кількох проєктів Tracklify, а залишок розподіляє між учасниками.',
    no_access_yet: 'У вас ще немає доступу до Profit-share проєкту.',

    all_participating: 'Усі проєкти-учасники',
    overview_reveal_hint: 'Ставки й витрати учасників лишаються конфіденційними, доки клітинку учасника за місяць не розкрито.',
    export_csv: 'Експорт CSV без учасників',
    no_operations: 'Відстежених операцій ще немає.',
    rate_missing: 'Немає ставки',
    vs_six_months: '{change} порівняно з 6 міс. тому',
    carry_over: '(перенесено {amount})',
    reveal_rate: 'Розкрити ставку',
    reveal_rate_aria: 'Розкрити ставку {member} за {month}',
    rate_line: 'ставка {rate}',
    mentor_line: '+ ментор {rate}',
    no_effective_rate: 'Немає чинної ставки',
    projects_loaded: 'Завантажено проєктів: {n}',
    load_details: 'Проєкт «{name}» завантажено за {seconds} с · запит агрегації {query} с',
    loading_operations: 'Завантаження операцій проєктів…',
    no_participating_selected: 'Проєкти-учасники не обрано.',
    add_revenue: 'Додати дохід',
    revenue: 'Дохід',
    latest: 'Останній',
    no_description: 'Без опису',
    rate_not_set: 'Ставку не задано',
    delete_revenue_confirm: 'Видалити цей дохід?',
    delete_revenue: 'Видалити дохід',
    no_revenue: 'Доходу ще немає',
    no_revenue_hint: 'Прибуток лишається від\'ємним, доки не додано дохід.',
    update_revenue: 'Оновити дохід',
    revenue_invalid: 'Сума і ставка мають бути додатними числами, наприклад 1200.50',
    col_month: 'Місяць',
    col_total_spend: 'Загальні витрати',
    col_rate_efficiency: 'Ефективність ставки',
    col_monthly_profit: 'Прибуток за місяць',
    col_distributable_profit: 'Прибуток до розподілу',
    col_accumulated_profit: 'Накопичений прибуток',

    tracklify_project: 'Проєкт Tracklify',
    rate_per_hour: 'Ставка ({currency}/год)',
    amount: 'Сума',
    currency: 'Валюта',
    date: 'Дата',
    sold_hours: 'Продані години',
    note: 'Примітка',
    note_placeholder: 'напр. рахунок за вересень',

    member_rates_title: 'Зарплатні ставки учасників',
    rates_hint: 'Одне оновлення на учасника на місяць. Ставка діє, доки її не замінить новіше оновлення.',
    rates_reveal_hint: 'Ставки лишаються конфіденційними, доки клітинку учасника за місяць не розкрито.',
    add_rate_update: 'Додати оновлення ставки',
    no_rates_warning: 'Ставок ще немає. Витрати й прибуток не можна порахувати, доки учасники, що трекають час, не мають ставки.',
    select_projects_first: 'Перш ніж додавати ставки, оберіть проєкти-учасники з підтвердженими учасниками.',
    no_rate_history: 'Історії ставок ще немає.',
    confidential_rate: 'Конфіденційна ставка',
    edit_rate: 'Редагувати ставку',
    mentor_rate_line: 'Ментор: {rate}',
    hours_not_estimated: 'Години не оцінено',
    add_monthly_rate: 'Додати місячне оновлення ставки',
    add_rate: 'Додати ставку',
    rates_invalid: 'Ставки мають бути числами, наприклад 25.50',
    member: 'Учасник',
    search_members: 'Пошук учасників',
    no_members_found: 'Учасників не знайдено',
    month: 'Місяць',
    new_rate: 'Нова ставка',
    mentor_rate: 'Ставка ментора',
    note_optional: 'Примітка (необов\'язково)',

    new_ps_project: 'Новий Profit-share проєкт',
    edit_ps_project: 'Редагувати Profit-share проєкт',
    project_name: 'Назва проєкту',
    project_name_placeholder: 'напр. Agency pool 2026',
    members_access: 'Учасники з конфіденційним доступом',
    add_members: 'Додайте учасників воркспейсу…',
    members_access_hint: 'Вони бачитимуть зарплатні ставки, витрати, дохід і прибуток.',
    access_list_author_only: 'Список конфіденційного доступу бачить лише автор проєкту.',
    participating_projects: 'Проєкти Tracklify, що беруть участь',
    add_projects: 'Додайте проєкти…',
    participating_hint: 'Цим списком керують адміни воркспейсу. Ставки спільні для всіх обраних проєктів.',
    create_project_btn: 'Створити проєкт',
    save_project: 'Зберегти проєкт',

    reveal_title: 'Розкрити конфіденційну ставку?',
    warning: 'Попередження',
    reveal_admin_text: 'Ви розкриваєте цю ставку як адміністратор, тому ця спроба не потрапить у журнал аудиту. Ті самі зобов\'язання щодо конфіденційності все одно діють.',
    reveal_member_text: 'Якщо продовжите, цю спробу розкриття буде назавжди записано в журнал аудиту від вашого імені. {member} зможе необмежено довго отримувати інформацію про цю спробу. Запис у журналі не можна видалити, а цю дію не можна скасувати.',
    confidential_caps: 'КОНФІДЕНЦІЙНО',
    confidential_text: 'Інформація про ставки суворо конфіденційна і може бути захищена угодою з учасником. Розкриваючи її, ви берете на себе повну відповідальність за збереження цієї інформації.',
    revealing: 'Розкриття…',
    reveal: 'Розкрити',

    confidential: 'Конфіденційно',
    consent_title: 'Чутлива інформація Profit-share',
    rule_see_title: 'Що ви побачите',
    rule_see_text: 'Цей Profit-share проєкт показує конфіденційні зарплатні ставки, відстежені витрати, дохід і прибуток.',
    rule_stop_title: 'Далі вас це не піде',
    rule_stop_text: 'Кожен учасник компанії має право зберігати в таємниці свою ставку, її історію та причини її зміни. Хоча прозорість моделі Profit-share робить розкриття авторизованим учасникам неминучим, будь-яке подальше поширення має зупинитися на тому, хто це переглядає.',
    rule_share_title: 'Не поширюйте й не фіксуйте',
    rule_share_text: 'Не можна поширювати чи фіксувати цю інформацію в публічних джерелах, скріншотах, записах екрана, повідомленнях чи будь-якій іншій формі. Передача цієї інформації будь-кому без доступу може призвести до вашого виключення з Profit-share. Tracklify автоматично розмиває скріншоти, зроблені, поки Profit-share відкрито.',
    consent_agree: 'Я розумію всі правила й погоджуюся, що мене можуть виключити з Profit-share, якщо я будь-яким чином поширю чи зафіксую конфіденційну інформацію.',
    asked_again: 'На новому пристрої чи в іншому браузері вас запитають знову.',
    agree_open: 'Погодитися й відкрити',

    audit_title: 'Журнал аудиту',
    audit_hint_full: 'Зміни доходу, зміни зарплатних ставок і розкриття конфіденційних ставок.',
    audit_hint_limited: 'Дії з доходом і ваші власні розкриття конфіденційних ставок.',
    loading_audit: 'Завантаження журналу аудиту…',
    no_audit: 'Записів аудиту ще немає.',
    page_info: 'Сторінка {page} з {pages} · записів: {total}',
    col_time: 'Час',
    col_user: 'Користувач',
    col_entity: 'Об\'єкт',
    col_action: 'Дія',
    col_diff: 'Зміни',
    filter_all_full: 'Уся фінансова активність',
    filter_all_limited: 'Дохід і мої дії',
    filter_salary: 'Зарплатні ставки',
    filter_reveals: 'Розкриття ставок',
    filter_my_reveals: 'Мої розкриття ставок',
    entity_salary: 'Зарплатна ставка',
    entity_reveal: 'Розкриття ставки',
  },
  invoices: {
    invoice_basis: 'Основа рахунку',
    close_invoice_basis: 'Закрити основу рахунку',
    close: 'Закрити',
    edit_filters: 'Змінити фільтри',
    projects: 'Проєкти',
    include_tags: 'Включити теги',
    exclude_tags: 'Виключити теги',
    executors: 'Виконавці',
    count_projects: 'Проєктів: {n}',
    count_incl_tags: 'Включ. тегів: {n}',
    count_excl_tags: 'Виключ. тегів: {n}',
    count_executors: 'Виконавців: {n}',
    block_formatting: 'Форматування блоку',
    font_size_value: 'Розмір шрифту: {size}',
    font_size: 'Розмір шрифту',
    alignment: 'Вирівнювання',
    column_width: 'Ширина стовпців',
    delete_block: 'Видалити блок',
    delete_text_cell: 'Видалити цю текстову клітинку',
    add_row_after: 'Додати рядок нижче',
    add_row_after_title: 'Додати новий рядок після цього',
    delete_column: 'Видалити стовпець',
    delete_column_title: 'Видалити цей стовпець з таблиці',
    confirm_delete: 'Підтвердити видалення?',
    confirm_deletion: 'Підтвердити видалення',
    cancel_deletion: 'Скасувати видалення',
    yes: 'Так',
    no: 'Ні',
    font_large: 'Великий шрифт (16px)',
    font_medium: 'Середній шрифт (14px)',
    font_small: 'Малий шрифт (12px)',
    font_extra_small: 'Дуже малий шрифт (10px)',
    align_left: 'Вирівняти ліворуч',
    align_center: 'Вирівняти по центру',
    align_right: 'Вирівняти праворуч',
    equal_width_columns: 'Стовпці однакової ширини',
    dynamic_width_columns: 'Стовпці динамічної ширини',
    invoice_generator: 'Генератор рахунків',
    invoice_layout: 'Макет рахунку',
    add_section: 'Додати розділ',
    add_text_section: 'Додати текстовий розділ',
    add_table_section: 'Додати таблицю',
    add_block_right: 'Додати блок праворуч',
    add_column_right: 'Додати стовпець праворуч',
    empty_block: 'Порожній блок',
    new_row_col: 'Новий рядок {row}, стовпець {col}',
    new_column: 'Новий стовпець {n}',
    delete_table: 'Видалити таблицю',
    delete_row: 'Видалити рядок',
    delete_table_title: 'Видалити всю таблицю',
    delete_row_title: 'Видалити цей рядок з таблиці',
    invoice_preview: 'Попередній перегляд рахунку',
    download: 'Завантажити',
    generating_pdf: 'Створюємо PDF…',
    opening_pdf_preview: 'Відкриваємо перегляд PDF…',
    page_of: 'Сторінка {current} з {total}',
    pdf_generation_failed: 'Не вдалося створити PDF',
    pdf_generation_error: 'Під час створення перегляду PDF сталася помилка. Спробуйте ще раз.',
    retry: 'Повторити',
    saving: 'Зберігаємо…',
    saved: 'Збережено',
    choose_template: 'Оберіть шаблон рахунку',
    choose_template_description: 'Оберіть збережений шаблон, щоб створити рахунок для відфільтрованих завдань, або почніть новий з нуля.',
    your_templates: 'Ваші шаблони',
    legacy_badge: 'LEGACY',
    shared_badge: 'СПІЛЬНИЙ',
    created_date: 'Створено {date}',
    created_colon_date: 'Створено: {date}',
    last_pdf: 'Останній PDF: {date}',
    never_capital: 'Ніколи',
    never: 'ніколи',
    or: 'або',
    create_new_template: 'Створити новий шаблон',
    template_name: 'Назва шаблону',
    save_name: 'Зберегти назву',
    cancel_renaming: 'Скасувати перейменування',
    name_cant_be_empty: 'Назва не може бути порожньою',
    rename_hint: 'Enter — зберегти · Esc — скасувати',
    duplicate_name: 'Дублювати {name}',
    duplicate: 'Дублювати',
    rename_name: 'Перейменувати {name}',
    rename: 'Перейменувати',
    delete_name: 'Видалити {name}',
    delete: 'Видалити',
    templates: 'Шаблони',
    find_template_placeholder: 'Знайти шаблон…',
    find_template: 'Знайти шаблон',
    no_templates_match: 'Немає шаблонів за запитом «{query}»',
    new_template: 'Новий шаблон',
    pinned: 'Закріплено',
    pinned_title: 'Системна закріплена змінна, існує завжди',
    auto: 'Авто',
    about_name: 'Про {name}',
    edit_name_description: 'Змінити опис {name}',
    edit_description: 'Змінити опис',
    unlock_name_value: 'Розблокувати значення {name}',
    lock_name_value: 'Заблокувати значення {name}',
    unlock_variable: 'Розблокувати змінну',
    lock_variable: 'Заблокувати змінну',
    enter_variable_description: 'Введіть опис змінної',
    available_variables: 'Доступні змінні',
    current_value: 'Поточне значення',
    no_variables_found: 'Не знайдено змінних, схожих на «{query}»',
    error_badge: 'ПОМИЛКА',
    template_and_basis: 'Шаблон і основа рахунку',
    reset: 'Скинути',
    unshare_template: 'Скасувати спільний доступ до шаблону',
    shared_click_to_unshare: 'Шаблон доступний робочому простору. Натисніть, щоб скасувати доступ',
    save_and_share_confirm: 'Зберегти шаблон і поділитися ним з робочим простором? Учасники бачитимуть ваш шаблон і змінні (лише перегляд).',
    share_confirm: 'Поділитися шаблоном з робочим простором? Учасники бачитимуть ваш шаблон і змінні (лише перегляд).',
    share_template: 'Поділитися шаблоном з робочим простором',
    share: 'Поділитися',
    legacy_template_notice: 'Це застарілий шаблон. Його не можна редагувати тут, але можна завантажити його HTML.',
    download_legacy_html: 'Завантажити застарілий HTML',
    template_variables: 'Змінні шаблону',
    template_owner: 'Власник шаблону',
    unknown_user: 'Невідомий користувач',
    current_marker: '(Поточний)',
    save_and_generate: 'Зберегти і створити',
    generate: 'Створити',
    delete_template_confirm: 'Ви впевнені, що хочете видалити цей шаблон?',
    unsaved_leave_message: 'Зберегти зміни в цьому шаблоні, перш ніж вийти з нього?',
    keep_editing: 'Продовжити редагування',
    untitled_template: 'Шаблон без назви',
    template_copy_name: '{name} (копія)',
  },
  salary: {
    salary_projects_breadcrumb: 'Зарплатні проєкти /',
    select_salary_project: 'Виберіть зарплатний проєкт',
    generates_monthly_on_day: 'Генерується щомісяця, день {day}',
    generates_weekly_on_day: 'Генерується щотижня, день {day}',
    recalculating_results: 'перераховуємо результати..',
    create_salary_project: 'Створити зарплатний проєкт',
    edit_salary_project: 'Редагувати зарплатний проєкт',
    confirm_delete_project: 'Ви впевнені, що хочете видалити цей зарплатний проєкт?',
    delete: 'Видалити',
    no_projects_yet: 'Зарплатних проєктів ще немає. Створіть перший, щоб почати.',
    current_period_not_settled: 'Поточний · {progress} · не закрито',
    day_progress: 'день {day} з {total}',
    members_count: 'Учасників: {n}',
    across_members: 'серед учасників: {n}',
    add_member: 'Додати учасника',
    search_members: 'Пошук учасників',
    add_member_to_current_period: 'Додати учасника до поточного періоду',
    member: 'Учасник',
    user_vars: 'Змінні користувача',
    calculated: 'Розраховано',
    export_column_csv: 'Експортувати цю колонку в CSV',
    confirm_remove_member: 'Видалити цього учасника з поточного періоду?',
    remove_member: 'Видалити учасника',
    summary: 'Підсумок',
    columns_count: 'Колонок: {shown} з {total}',
    metric_min: 'мін',
    metric_avg: 'сер',
    metric_max: 'макс',
    metric_median: 'медіана',
    metric_sum: 'сума',
    show_min: 'Показати мін',
    show_avg: 'Показати сер',
    show_max: 'Показати макс',
    show_median: 'Показати медіану',
    show_sum: 'Показати суму',
    select_project_from_list: 'Виберіть зарплатний проєкт зі списку вище.',
    popup_subtitle: 'Зарплати генеруються автоматично за розкладом.',
    project_name: 'Назва проєкту',
    project_name_placeholder: 'напр. Київська команда',
    frequency: 'Частота',
    week: 'Тиждень',
    month: 'Місяць',
    day_of_month: 'День місяця',
    day_of_week: 'День тижня',
    of_max_day: 'з {max}',
    timezone: 'Часовий пояс',
    select_timezone: 'Виберіть часовий пояс',
    recreate_to_change_settings: '(щоб змінити налаштування вище, створіть проєкт заново)',
    variables: 'Змінні',
    add_variable: 'Додати змінну',
    no_variables_yet: 'Змінних ще немає. Додайте значення для кожного учасника, як-от базова зарплата чи погодинна ставка.',
    move_up: 'Перемістити вгору',
    move_down: 'Перемістити вниз',
    create_project: 'Створити проєкт',
    average_salary: 'Середня зарплата',
    total_hours: 'Усього годин',
    predicted_salary: 'Прогнозована зарплата',
    actually_earned: 'Фактично зароблено',
    own_hours: 'Власні години',
    end_of_month_forecast: 'прогноз на кінець місяця',
    base_percent_hint: 'база {base} · {percent}% від бази',
    incl_base_in_eur: 'з урахуванням бази · в EUR',
    at_rate_per_hour: 'за ставкою {rate}/год',
    not_receiving_salary_yet: 'ви ще не отримуєте зарплату в цьому проєкті',
    var_desc_user_time_spent: 'Час користувача (години) за період; необов\'язково: 3-й аргумент = email, 4-й аргумент = назва проєкту',
    var_desc_user_prediction_median: 'Медіана USER_TIME_SPENT за попередні N періодів (години); необов\'язкові фільтри email/проєкт',
    var_desc_min: 'Повертає мінімальне з двох числових аргументів',
    var_desc_previous_salary_point: 'Баланс попереднього зарплатного запису',
    var_desc_user_vars: 'Власна змінна користувача (замініть var_name на свій ключ)',
    var_desc_exchange_rate: 'Курс обміну {alias}',
    var_desc_exchange_rate_month_start: 'Курс НБУ на 1-й день місяця періоду (USD-UAH, EUR-UAH, PLN-UAH, CAD-UAH)',
    var_desc_previously_defined: 'Раніше визначена змінна',
    csv_copied: 'CSV скопійовано в буфер обміну',
    csv_copy_failed: 'Не вдалося скопіювати CSV. Спробуйте ще раз.',
  },
  tags: {
    burned_hours: 'Витрачені години',
    planned: 'Заплановано',
    passed: 'Виконано',
    est_h: 'Оцінка, год',
    tracked: 'Затрекано',
    burned: 'Витрачено',
    avg_velocity: 'Сер. швидкість',
    before_sprint: 'До спринту',
    during_sprint: 'Під час спринту',
    all_projects: 'Усі проєкти',
    all_sprint_tasks: 'Усі завдання спринту',
    non_own_sprint_tasks: 'Чужі завдання спринту',
    non_this_project: 'Інші проєкти',
    effort_change: 'Зміна зусиль',
    native_level: 'Рівень у проєкті',
    altruist: 'Альтруїзм',
    sprint_start: 'Початок спринту',
    weekends_per_week: 'Вихідних / тиждень',
    days_in_sprint: 'Днів у спринті',
    show_velocity_stats: 'Показати статистику швидкості',
    show_main_stats: 'Показати основну статистику',
    burndown: 'Burndown',
    remaining_vs_ideal_pace: 'Залишок годин порівняно з ідеальним темпом',
    remaining: 'Залишок',
    ideal: 'Ідеал',
    remaining_hours: 'Залишок годин',
    ideal_burndown: 'Ідеальний burndown',
    tag_focus_hotkey: 'Фокус на тегу (Alt+G)',
    tag_focus: 'Фокус на тегу',
    unfocus: 'Зняти фокус',
    filter_tags: 'Фільтрувати теги...',
    show_eta: 'Показати ETA',
    calculate_eta: 'Розрахувати ETA',
    export_settings: 'Налаштування експорту',
    include_executor: 'Додати виконавця',
    hours_in_story_point: 'Годин у story point',
    round_up_to: 'Округлювати до',
    include_doing_hint: 'Чи додавати колонку «doing», щоб клієнт міг вмикати/вимикати пункти чекбоксом',
    include_doing: 'Додати колонку Doing',
    notdoing_tag: 'Тег «Notdoing»',
    select_label: 'Оберіть тег',
  },
  pages: {
    access_denied_title: 'Нам шкода',
    access_denied_subtitle: 'Щось пішло не так, і вас було виведено з активного робочого простору.',
    access_denied_select_workspace: 'Оберіть робочий простір, щоб продовжити',
    access_denied_no_workspaces: 'У вас ще немає доступних робочих просторів.',
    access_denied_create_new: 'Створити новий',
    access_denied_logged_in_as: 'Ви увійшли як {email}',
    access_denied_login_another: 'Увійти в інший акаунт',
    ai_automation_other_client: 'Інше',
    app_download_not_uploaded: 'Не завантажено',
    mcp_authorize_title: 'Підключити {client}?',
    mcp_authorize_acts_on_behalf: '{client} ({host}) просить дозволу діяти від вашого імені в робочому просторі {workspace}: він бачитиме та змінюватиме все, що можете ви.',
    mcp_authorize_loopback_warning: 'Після відповіді браузер поверне вас до застосунку, що працює на цьому комп\'ютері. Дозволяйте, лише якщо ви щойно самі почали підключати {client}.',
    mcp_authorize_redirect_notice: 'Після відповіді браузер поверне вас на {host}.',
    mcp_authorize_deny: 'Відхилити',
    mcp_authorize_allow: 'Дозволити',
    mcp_authorize_invalid: 'Цей запит на авторизацію недійсний або прострочений. Почніть підключення знову з вашого MCP-клієнта.',
    project_no_projects_title: 'У вас ще немає проєктів 👀',
    project_no_projects_hint: 'Будь ласка, {create_project} у меню зліва вгорі, натиснувши {no_projects}',
    project_create_project: 'створіть проєкт',
    project_no_projects: 'Немає проєктів',
    project_settings_loading: 'Завантаження...',
    integrations_add: 'Додати інтеграцію',
    integrations_added_by: 'Додав {name} · {date}',
    integrations_unknown_user: 'Невідомо',
    integrations_close_config: 'Закрити налаштування',
    integrations_config: 'Налаштування',
    integrations_delete_confirm: 'Видалити цю інтеграцію?',
    integrations_default_description: 'Інтеграція {name}',
    downtime_snooze_title: 'Відкласти на 10 хвилин',
    task_notify_priority_title: 'Пріоритет: {priority}',
    report_export_preparing: 'Підготовка…',
  },
  ui: {
    ai_chat_empty: 'Попросіть мене показати ваші проєкти або створити завдання.',
    ai_chat_error: 'Помилка: {error}',
    ai_chat_openai_auth_error: 'AI-асистент недоступний: ключ OpenAI API недійсний або прострочений.',
    ai_chat_something_went_wrong: 'Щось пішло не так',
    checklist_progress_title: 'Прогрес чекліста: виконано {done} з {total}',
    close_button_title: 'Закрити [ESC]',
    comment_integration: 'Інтеграція',
    comment_unknown_user: 'Невідомий',
    common_header_create_task_title: 'Створити завдання [Alt+N]',
    create_task_error_reading_file: 'Помилка читання файлу. Спробуйте ще раз.',
    download_mobile_back: 'Назад',
    download_mobile_install_app: 'Встановити застосунок',
    editor_sign_up_not_confirmed: 'Реєстрацію не підтверджено',
    header_hidden_members: 'Ще учасників у проєкті: {count}',
    hidden_screenshot_tooltip_in_project: 'Ви не можете переглянути цей скріншот, бо не є учасником проєкту {projectName}',
    hidden_screenshot_tooltip_no_project: 'Ви не можете переглянути цей скріншот, бо не є учасником цього проєкту',
    hidden_task_tooltip_in_project: 'Ви не можете переглянути це завдання, бо не є учасником проєкту {projectName}',
    hidden_task_tooltip_no_project: 'Ви не можете переглянути це завдання, бо не є учасником цього проєкту',
    integration_bot_name: 'Ім\'я',
    integration_bot_title: 'Бот',
    integration_param_readonly: 'лише читання',
    pager_try_again_later: 'Спробуйте пізніше',
    recording_controls_microphone_level: 'Рівень мікрофона',
    recording_controls_pause_title: 'Призупинити запис екрана',
    recording_controls_resume_title: 'Продовжити запис екрана',
    recording_controls_stop_title: 'Зупинити запис екрана',
    searcher_no_tags: 'без тегів',
    searcher_with_tag: 'З тегом:',
    spinner_loading: 'Завантаження...',
    stage_enter_new_name: 'Назва стадії не може бути порожньою',
    stage_no_name: 'Стадія без назви',
    task_click_to_assign: 'Натисніть, щоб призначити',
    task_dialog_comments_only: 'Лише коментарі',
    task_dialog_drop: 'Перетягніть сюди',
    task_dialog_logs_shown: 'Логи показано',
    task_dialog_parent_task: 'Батьківське завдання',
    task_dialog_return_to_parent: 'Повернутися до батьківського завдання',
    task_dialog_scroll_to_top: 'Прокрутити вгору',
    task_dialog_subtasks: 'Підзавдання',
    task_dialog_subtasks_caption: 'ПІДЗАВДАННЯ',
    task_dialog_toggle_rightbar: 'Деталі завдання',
    task_right_bar_add_subtask_title: 'Додати підзавдання [Alt+Ctrl+N]',
    user_avatar_executor_title: '{username} — виконавець цього завдання',
  },
};
